import { render, staticRenderFns } from "./page_foot.vue?vue&type=template&id=3c073f29&scoped=true&"
import script from "./page_foot.vue?vue&type=script&lang=js&"
export * from "./page_foot.vue?vue&type=script&lang=js&"
import style0 from "./page_foot.vue?vue&type=style&index=0&id=3c073f29&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c073f29",
  null
  
)

export default component.exports